// Tag — thin wrapper over antd's Tag adding a `mono` face switch. Lived at
// ui/vendor/corenet/components/Tag/ as a hand-edit to the vendored copy
// (against VENDORED.md's own "don't hand-edit here" rule) until a corenet
// sync (2026-09-10) deleted Tag from corenet entirely — upstream dropped
// ALL of its thin AntD pass-through wrappers in favor of importing AntD
// directly (see cloudctlplane commit a94aa5df8, "corenet: cleanup
// (wrappers, charts, raw-AntD)"). corenet's own Tag really was a bare
// pass-through with zero logic; ours has a real, used feature (`mono`), so
// it moves here instead of disappearing with the sync.
import { Tag as AntTag } from "antd";
import type { TagProps as AntTagProps } from "antd";

export type TagProps = AntTagProps & {
  /**
   * Renders the tag's content in the shared monospace face
   * (var(--font-mono)) instead of the default sans. Reach for this when
   * the tag's content is an identifier — a hostname, a policy tier name,
   * a job/grant state — rather than a plain-English word or phrase (e.g.
   * "Enforcing" / "Not enforcing" stays sans, and so does a friendly size
   * tier like "Medium"; "citizen-dev" or "success" takes mono). Not named
   * `variant` — antd's Tag already has its own `variant` prop
   * (filled/outlined/borderless); this is a separate, combinable axis.
   */
  mono?: boolean;
};

export function Tag({ mono, style, ...props }: TagProps) {
  return (
    <AntTag
      {...props}
      style={mono ? { fontFamily: "var(--font-mono)", ...style } : style}
    />
  );
}

export default Tag;
